import React from 'react'
import ContextMenu from '../ContextMenu'

import './style.scss'

class TagMenu extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isContextMenuOpen: false
    }

    this.handlers = {
      closeContextMenu: this.closeContextMenu.bind(this),
      openContextMenu: this.openContextMenu.bind(this)
    }
  }

  closeContextMenu() {
    document.body.classList.remove('context-menu-close')

    this.setState({
      isContextMenuOpen: false
    })
  }

  openContextMenu() {
    if (this.state.isContextMenuOpen === true) {
      this.closeContextMenu()
      return
    }

    document.body.classList.add('context-menu-open')

    this.setState({
      isContextMenuOpen: true
    })
  }

  render() {
    return (
      <div className="tag-menu">
        <span onClick={() => this.openContextMenu()}/>
        {
          this.state.isContextMenuOpen && <ContextMenu
            {...this.handlers}
            {...this.props}
          />
        }
      </div>
    )
  }
}

export default TagMenu
